/**
 * REVIVIFEYE — Reviews Strip Carousel
 * Arrow-controlled horizontal scroll with snap
 */
class ReviewsStrip {
  constructor(section) {
    this.section = section;
    this.track   = section.querySelector('.rs__track');
    this.prev    = section.querySelector('.rs__arrow--prev');
    this.next    = section.querySelector('.rs__arrow--next');

    if (!this.track) return;

    this._bind();
    this._updateArrows();
  }

  _cardStep() {
    const card = this.track.querySelector('.rs__card');
    if (!card) return 320;
    const style = getComputedStyle(this.track);
    const gap   = parseFloat(style.columnGap) || parseFloat(style.gap) || 16;
    return card.offsetWidth + gap;
  }

  scrollPrev() {
    this.track.scrollBy({ left: -this._cardStep(), behavior: 'smooth' });
  }

  scrollNext() {
    this.track.scrollBy({ left: this._cardStep(), behavior: 'smooth' });
  }

  _updateArrows() {
    if (!this.prev || !this.next) return;
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.prev.disabled = scrollLeft <= 2;
    this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
  }

  _bind() {
    this.prev?.addEventListener('click', () => this.scrollPrev());
    this.next?.addEventListener('click', () => this.scrollNext());
    this.track.addEventListener('scroll', () => this._updateArrows(), { passive: true });

    // Keyboard on the section
    this.section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.scrollPrev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.scrollNext(); }
    });
  }
}

function initReviewsStrip(root = document) {
  root.querySelectorAll('.rs-section').forEach((section) => {
    if (!section._rs) section._rs = new ReviewsStrip(section);
  });
}

document.addEventListener('DOMContentLoaded', () => initReviewsStrip());
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.rs-section')) {
    const sec = e.target.querySelector('.rs-section');
    sec._rs = null;
    initReviewsStrip(e.target);
  }
});
